export default __webpack_public_path__ + "static/media/intro-image.f091f425.jpg";